import React from "react";
import { RevealOnMount } from "src/components/reveal-on-mount";
import { SEO } from "src/components/SEO";
import { MetaInfo } from "src/types/meta";
import {
	SustainabilityIntro,
	SustainabilityIntroProps,
} from "src/components/sustainability/intro";
import {
	SustainabilityOfferings,
	SustainabilityOfferingsProps,
} from "src/components/sustainability/offerings";
import {
	SustainabilityBCorpCopy,
	SustainabilityBCorpCopyProps,
} from "src/components/sustainability/b-corp-copy";
import {
	SustainabilityWhat,
	SustainabilityWhatProps,
} from "src/components/sustainability/what";
import {
	SustainabilityQuote,
	SustainabilityQuoteProps,
} from "src/components/sustainability/quote";
import {
	SustainabilityCertifications,
	SustainabilityCertificationsProps,
} from "src/components/sustainability/certifications";

import { blocksToPlainText } from "src/utils/blocksToPlainText";

export interface SustainabilityProps {
	data: {
		main: {
			slug: {
				current: string;
			};
			title: string;
			intro: SustainabilityIntroProps;
			offerings: SustainabilityOfferingsProps;
			bCorp: SustainabilityBCorpCopyProps;
			what: SustainabilityWhatProps;
			quote: SustainabilityQuoteProps;
			certifications: SustainabilityCertificationsProps;
		};
		meta: {
			metaTitle?: string;
			metaDescription?: string;
			openImage?: any;
			twitterImage?: any;
		};
	};
	location: any;
}

const SustainabilityTemplate = ({ location, data }: SustainabilityProps) => {
	const { main, meta } = data;

	// set fallback meta tags from content
	const metaInfo: MetaInfo = {
		metaTitle: meta?.metaTitle || main.title,
		metaDescription:
			meta?.metaDescription || blocksToPlainText(main.intro.copy),
		openImage: meta?.openImage || main.intro?.media?.image,
		twitterImage:
			meta?.twitterImage || meta?.openImage || main.intro?.media?.image,
	};

	return (
		<RevealOnMount location={location}>
			<SEO
				metaInfo={metaInfo}
				pagePath={location?.pathname}
				slug={main.slug.current}
			/>
			<SustainabilityIntro data={main.intro} />
			<SustainabilityOfferings data={main.offerings} />
			{main.bCorp.show && <SustainabilityBCorpCopy data={main.bCorp} />}
			<SustainabilityWhat data={main.what} />
			{main.quote.show && <SustainabilityQuote data={main.quote} />}
			<SustainabilityCertifications data={main.certifications} />
		</RevealOnMount>
	);
};

export default SustainabilityTemplate;
